<template>
	<div> 
		<div class="row">
			<div class="col text-left">
				<span class="add-user-text"> Přidat nového uživatele </span>
			</div>
		</div>

		<div class="row justify-content-md-center mt-2">
			<div class="col-lg-4">
				<div class="form-group text-left">
					<label for="userName"> Uživatelské jméno </label> 
					<input autocomplete="false" type="text" class="form-control" id="userName" placeholder="Uživatelské jméno" v-model="newUserName" />
				</div>
			</div>
		</div>

		<div class="row justify-content-md-center mt-2">
			<div class="col-lg-4">
				<div class="form-group text-left">
					<label for="userName"> Email </label> 
					<input autocomplete="false" type="text" class="form-control" id="userEmail" placeholder="E-mail uživatele" v-model="newUserMail" />
				</div>
			</div>
		</div>

		<div class="row justify-content-md-center mt-2">
			<div class="col-lg-4">
				<div class="form-group text-left">
					<label for="userPass"> Heslo </label> 
					<input autocomplete="false" type="password" class="form-control" id="userPass" placeholder="Heslo" v-model="newUserPassword" />
				</div>
			</div>
		</div>

		<div class="row justify-content-md-center">
			<div class="col-lg-4">
				<div class="form-group text-left">
					<label for="userPassTwo"> Heslo znovu </label> 
					<input autocomplete="false" type="password" class="form-control" id="userPassTwo" placeholder="Heslo znovu" v-model="newUserPasswordChecker" />
				</div>
			</div>
		</div>

		<div class="row justify-content-md-center">
			<div class="col-lg-4">
				<div v-if="passwordsDoNotMatch" class="passwords-not-match"> Hesla se neshodují!  </div>
			</div>
		</div>

		<div class="row justify-content-md-center">
			<div class="col-lg-4">
				<button class="btn btn-success" :class="{ 'move-bitch': (! passwordsDoNotMatch) }"  @click="addNewUser()"> Přidat </button>
			</div>
		</div>
	</div>
</template>

<script>
import AdditionsService from '@/services/AdditionsService'


export default {
	name: 'AddUser',

	data () {
		return {
			newUserName: null,
			newUserPassword: null,
			newUserPasswordChecker: null,
			passwordsDoNotMatch: false,
			newUserMail: null,
		}
    },
    
    created() {

    },	

	methods: {
        async addNewUser () {
			if (! this.newUserName || ! this.newUserPassword)  {
				return
			}

			if (this.newUserPassword !== this.newUserPasswordChecker) {
				this.passwordsDoNotMatch = true
				return
			} else {
				this.passwordsDoNotMatch = false
			}

			const added = await AdditionsService.addNewUser(this.newUserName, this.newUserPassword, this.newUserMail)

			if (added.data) {
				this.$emit('newUserAdded')
			}

			this.newUserName = null
			this.newUserPassword = null
			this.newUserPasswordChecker = null
			this.newUserMail = null
		},
	},
}
</script>

<style lang="stylus" scoped>

.add-user-input 
	display flex
	flex-direction column
	padding-left 50px
	margin-top 10px
	padding-bottom 30px

.add-user-text 
	font-weight bold
	font-size 20px

.a-u-input 
	background-color white

.second 
	margin-top 10px

.passwords-not-match 
	width 150px
	color red
	font-size 15px
	font-weight bold
	height 30px

.add-user-button 
	width 150px
	height 40px
	color white
	font-weight bold
	background-color rgb(1, 141, 134)
	border none

.move-bitch 
	margin-top 30px !important

</style>



// WEBPACK FOOTER //
// src/components/users/AddUser.vue